import "@gweb/ui/styles.css";
import "./app.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <BrowserRouter>
      <App apiBase={import.meta.env.VITE_API_BASE ?? ""} allowDevToken={import.meta.env.DEV || import.meta.env.VITE_ALLOW_DEV_TOKEN === "true"} />
    </BrowserRouter>
  </StrictMode>,
);
